module.exports = __webpack_public_path__ + "static/media/DNC_white.0302f6de.png";